import { Input, Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs';
import { ButtonWidget } from '@overview/models/button-widget';
import { Direction } from '@common/enums/direction';
import { DashboardScrollService } from '@dashboards/services/dashboard-scroll.service';
import { DeviceDetectorService } from '@common/device-detection/services/device-detector.service';

@Component({
    selector: 'mojo-overview-nav',
    templateUrl: './overview-nav.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class OverviewNavComponent implements OnInit {

  @Input()
  tiles$: Observable<ButtonWidget[]>;

  scrollingDownOnMobile = new Observable<boolean>();

  constructor(
    dashboardScrollService: DashboardScrollService,
    deviceDetectorService: DeviceDetectorService
  ) {
    const isMobile = deviceDetectorService.isMobile() || deviceDetectorService.isTablet();
    this.scrollingDownOnMobile = dashboardScrollService.getScrollDirection().pipe(map(direction => isMobile && direction === Direction.Down ));
  }

  ngOnInit() {
  }
}
